import React from 'react';
import {Position} from 'cytoscape';
import {
    GraphEdge,
    GraphLayout,
    GraphNode,
    QueryGraphLayoutAlgorithm
} from '../../../../../../components/graph/interface';
import {useCalculateLayout} from '../../../../../../components/graph/graph-logic/use-calculate-layout';
import {
    defaultPan,
    defaultZoom
} from '../../../../../query-workflow/query-layout/completed-query/results-graph/use-camera-props';

interface Props {
    nodes: GraphNode[];
    edges: GraphEdge[];
}

export function useNeighborhoodGraphProps(props: Props) {
    const [isBrowserUnsupported, setIsBrowserUnsupported] = React.useState<boolean>();
    const [nodePositions, setNodePositions] = React.useState<string>('');
    const [zoom, setZoom] = React.useState<number>(Number(defaultZoom));
    const [pan, setPan] = React.useState<Position>(defaultPan);

    const calculateLayoutRef = React.useRef<ReturnType<typeof useCalculateLayout>>(undefined);
    calculateLayoutRef.current = useCalculateLayout({
        setIsBrowserUnsupported,
        nodes: props.nodes,
        edges: props.edges,
        layoutAlgorithm: QueryGraphLayoutAlgorithm.LAYERED_VERTICAL,
        onCalculated: (newPositions: string) => {
            setNodePositions(newPositions);
            setZoom(Number(defaultZoom));
            setPan(defaultPan);
        }
    });

    const nodesToString = props.nodes.toString();
    React.useEffect(() => {
        setNodePositions('');
        calculateLayoutRef.current!.calculateLayout();
    }, [nodesToString]);

    return {
        pan,
        zoom,
        setPan,
        setZoom,
        setNodePositions,
        isBrowserUnsupported,
        nodePositions: nodePositions ? (JSON.parse(nodePositions) as GraphLayout) : undefined,
        handleNodeMoved: React.useCallback(
            (newLayout: GraphLayout) => setNodePositions(JSON.stringify(newLayout)),
            []
        )
    };
}
